import { Decimal } from 'decimal.js';
/** Adds quantities as decimals, so 0.1 + 0.2 is exactly 0.3 at any magnitude where a Decimal(28,9) column can hold it. */
export function sumQuantities(values) {
    return values.reduce((sum, value) => sum.plus(value), new Decimal(0)).toNumber();
}
//# sourceMappingURL=sum-quantities.js.map